import { render } from "./BookDetail.vue?vue&type=template&id=c85dee34&scoped=true&ts=true"
import script from "./BookDetail.vue?vue&type=script&lang=ts"
export * from "./BookDetail.vue?vue&type=script&lang=ts"

import "./BookDetail.vue?vue&type=style&index=0&id=c85dee34&lang=scss&scoped=true"

import exportComponent from "/root/workspace/lll-ui_hccl/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c85dee34"]])

export default __exports__